import { useQuery } from "@tanstack/react-query";
import { fetchAllGlGroup } from "@Services/UserService";
import { React_Query_Keys } from "@utils/constants";

export const useGlGroupFetchAll = () => {
  return useQuery({
    queryKey: [React_Query_Keys.FETCH_ALL_GL_GROUP],
    queryFn: () => fetchAllGlGroup()
  });
};
